export const routes = {
  dashboard: 'dashboard',
  products: 'product', //changed from "products" to "product" to allow default routing to dashboard
  submissions: 'submissions',
  scipPreferences: 'scip-preferences',
  envOverview: 'env-overview',
  logout: 'logout'
};
